import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { MDBBootstrapModulesPro, MDBSpinningPreloader, ToastModule } from 'ng-uikit-pro-standard';
// pages references
import { APP_ROUTING } from './app.routes';
// Menu
import { NavbarSidebarComponent } from './shared/navbar-sidebar/navbar-sidebar.component';
// login Module
// Eng Project Module
// Training Module
// FAQ Module
// Help Module
// Home module
// Admin tools Module
// User administration module

// http service
import { UserService } from './services/user.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth/auth-interceptor';

import { DataService } from "./shared/data-service/data.service.service";


import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ResponsiveComponent } from './pages/home/responsive/responsive.component'

import { ThemeService } from './services/theme.service'


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// import { EditProjectComponent } from './pages/sales-management/sales-project/edit-project/edit-project.component';

import { AppConfigService } from './app-config.service.service';
// devexpress
// tslint:disable-next-line: max-line-length
// import { DxSchedulerModule, DxAccordionModule,DxDataGridComponent, DxSliderModule, DxTagBoxModule, DxDataGridModule, DxCheckBoxModule, DxScrollViewModule,DxAutocompleteModule, DxSchedulerComponent, DxTemplateModule, DxGanttModule, DxDiagramModule, DxDiagramComponent, DxContextMenuModule, DxButtonModule, DxPopupModule, DxTextBoxModule, DxDateBoxModule, DxSelectBoxModule, DxNumberBoxModule, DxRangeSliderModule, DxFormModule, DevExtremeModule } from "devextreme-angular";
// import { Service, MovieData, TheatreData, Data } from './services/app.service';
import { Service, PriorityData, TypeData } from 'src/app/services/app.service';


import { LoadingInterceptor } from './shared/LoadingInterceptor';
import { ErrorInterceptor } from './shared/ErrorInterceptor';
import { CurrencyPipe, DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
// import { LoginV2Component } from './pages/login-v2/login-v2/login-v2.component';

import { DefaultLayoutComponent } from './shared/default-layout/default-layout.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranlationConfigModule } from './tranlation-config/tranlation-config.module';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { MdbWysiwygModule } from 'mdb-wysiwyg';
import { MdbSortableModule } from 'mdb-sortable';
import { MdbFileUploadModule } from 'mdb-file-upload';
import { DevExtremeModule, DxSchedulerModule, DxTextBoxModule } from 'devextreme-angular';
import { MdbGlobalModule } from './shared/mdb-global.module';
import { NavbarSidebarModule } from './shared/navbar-sidebar/navbar-sidebar.module';
import { LoginRecoverPasswdCSComponent } from './pages/login-v2/login-recover-passwd-cs/login-recover-passwd-cs.component';
//import { ConfigGridComponent } from './pages/cube-settings/config-grid/config-grid.component';
// import { PartCategoriesComponent } from './pages/inventory/part-categories/part-categories.component';

// Google Maps
import { AgmCoreModule } from '@agm/core';
// import { GoogleMapsModule } from '@angular/google-maps';

// Config map
import { AppConfiguration } from './config/app-configuration';
import {JsonAppConfigService} from './config/json-app-config.service';
import { TruncatePipe } from './custom-pipe/TruncatePipe';
import { DinamicModalModule } from './shared/dinamic-modal/dinamic-modal.module';
// import { ProductsCartComponent } from './pages/shop/products-cart/products-cart.component';
// import { KbsComponent } from './pages/education/kbs/kbs.component';
//import { CustomerWebinarsComponent } from './pages/cube-settings/customer-webinars/customer-webinars.component';
//import { CompanyNotificationComponent } from './pages/cube-settings/company-notification/company-notification.component';
//import { ReportDesignerComponent } from './shared/report-designer/report-designer.component';
// import { ClientActivationComponent } from './pages/admin-tools/client-activation/client-activation.component';
//import { CubeReleasesComponent } from './pages/admin-tools/cube-releases/cube-releases.component';
// import { ReportViewerComponent } from './shared/report-viewer/report-viewer.component';
//import { ServiceRecommendationsComponent } from './pages/service-management/service-recommendations/service-recommendations.component';
// import { VehiclesComponent } from './pages/cube-settings/vehicles/vehicles.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ConfigureImageSvgComponent } from './pages/admin-tools/configure-image-svg/configure-image-svg.component';
import { LoginCubeShopComponent } from './pages/login-v2/login-v2/login-cubeshop/login-cubeshop.component';
import { RegisterCubeShopUserComponent } from './pages/login-v2/login-v2/create-cubeshop-user/register-cubeshop-user.component';
// import { MyJobsDetailsComponent } from './pages/cubeWork/my-jobs-details/my-jobs-details.component';
// import { MyJobsComponent } from './my-jobs/my-jobs.component';
// import { OfferViewComponent } from './pages/cubeWork/offer-view/offer-view.component';
// import { FindWorkComponent } from './pages/cubeWork/find-work/find-work.component';
// import { MyProposalsComponent } from './pages/cubeWork/my-proposals/my-proposals.component';
// import { ProfileTalentComponent } from './pages/cubeWork/profile-talent/profile-talent.component';
// import { SettingsCubeWorkComponent } from './settings-cube-work/settings-cube-work.component';
// import { ReportsWorkCubeComponent } from './reports-work-cube/reports-work-cube.component';
// import { JobsComponent } from './pages/cubeWork/jobs/jobs.component';
// import { ContractsComponent } from './pages/cubeWork/contracts/contracts.component';
// import { JobPostComponent } from './pages/cubeWork/job-post/job-post.component';
// import { ClientDasboardComponent } from './pages/cubeWork/client-dasboard/client-dasboard.component';
// import { MyFeedComponent } from './pages/cubeWork/my-feed/my-feed.component';
// import { SearchJobComponent } from './pages/cubeWork/search-job/search-job.component';
// import { MyAccountComponent } from './pages/user-administration/my-account/my-account.component';
//import { MyCartComponent } from './pages/shop/my-cart/my-cart.component';
//import { ApplicationsComponent } from './pages/shop/applications/applications.component';
//import { YourOrderComponent } from './pages/shop/your-order/your-order.component';
//import { OrderDetailComponent } from './pages/shop/order-detail/order-detail.component';
//import { OrderComponent } from './pages/shop/order/order.component';
//import { AddNewShippingComponent } from './pages/shop/add-new-shipping/add-new-shipping.component';
// import { ShippingAddressComponent } from './pages/shop/shipping-address/shipping-address.component';
// import { AddNewPaymentComponent } from './pages/shop/add-new-payment/add-new-payment.component';
// import { ProductsDetailsComponent } from './pages/shop/products-details/products-details.component';
// import { MyProjectsComponent } from './pages/my-projects/my-projects.component';



const appInitializerFn = (appConfig: AppConfigService) => {
  return () => {
    return appConfig.loadAppConfig();
  };
};

export function initializerFn(jsonAppConfigService: JsonAppConfigService){
  return () => {
    return jsonAppConfigService.load();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginCubeShopComponent,
    DefaultLayoutComponent,
    LoginRecoverPasswdCSComponent,
    RegisterCubeShopUserComponent,
    ResponsiveComponent,
    // MyJobsDetailsComponent,
    // MyJobsComponent,
    // OfferViewComponent,
    // FindWorkComponent,
    // MyProposalsComponent,
    // ProfileTalentComponent,
    // SettingsCubeWorkComponent,
    // ReportsWorkCubeComponent,
    // JobsComponent,
    // ContractsComponent,
    // JobPostComponent,
    // ClientDasboardComponent,
    // MyFeedComponent,
    // SearchJobComponent,
    // MyAccountComponent,
    //MyCartComponent,
//    ApplicationsComponent,
    //YourOrderComponent,
    //OrderDetailComponent,
  //  OrderComponent,
  //  AddNewShippingComponent,
    // ShippingAddressComponent,
    // AddNewPaymentComponent,
    // MyProjectsComponent,
    // ProductsDetailsComponent,
    // ProductsCartComponent,
    // KbsComponent,
    //CustomerWebinarsComponent,
    //CompanyNotificationComponent,
    //ReportDesignerComponent,
  //  ClientActivationComponent,
  //  CubeReleasesComponent,
    // ReportViewerComponent
    //ServiceRecommendationsComponent
    // VehiclesComponent,
    // GoogleMapsModule
    //ConfigGridComponent
    // PartCategoriesComponent
   ],
  imports: [
    // NgbModule.forRoot(),
    DevExtremeModule,
    NavbarSidebarModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    MdbGlobalModule,
    ToastModule.forRoot({
      positionClass: 'md-toast-bottom-left',
    }),
    TranlationConfigModule.forRoot(),
    DinamicModalModule,
    APP_ROUTING,
    // GoogleMapsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD-LC1IRlirpLm8n6GjaCLTsR9cTJ_NT68',
      libraries: ['places']
    }),
    RecaptchaModule
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    TruncatePipe,
    ThemeService,
    // TranslatePipe,
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService]
    },
    MDBSpinningPreloader,
    DataService,
    // Service, MovieData, TheatreData, Data,
    Service, PriorityData, TypeData,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: AppConfiguration,
      deps: [HttpClient],
      useExisting: JsonAppConfigService
    },

    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [JsonAppConfigService],
      useFactory: initializerFn
    }],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppModule { }
